import { ReactElement } from 'react';
import { Alert, AlertTitle, Chip, Snackbar } from '@mui/material';
import { useIntl } from 'react-intl';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';

/** "A new version of the application is available" with a refresh, at the bottom of the page. */
export function ServiceWorkerUpdateAlert({ onRefresh }: { onRefresh: () => void }): ReactElement {
  const intl = useIntl();

  return (
    <Snackbar open={true} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert severity='info'>
        <AlertTitle>{formatTranslation(intl, CommonTranslationKeys.serviceWorkerUpdateMessage)}</AlertTitle>
        <Chip onClick={onRefresh} label={formatTranslation(intl, CommonTranslationKeys.refresh)} />
      </Alert>
    </Snackbar>
  );
}
